if (!customElements.get('product-gallery-controls')) {
  customElements.define(
    'product-gallery-controls',
    class extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('media-gallery');
        this.previousButton = this.querySelector('[data-gallery-previous]');
        this.nextButton = this.querySelector('[data-gallery-next]');
        if (!this.gallery || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.showMedia(-1));
        this.nextButton.addEventListener('click', () => this.showMedia(1));

        this.observer = new MutationObserver(() => this.updateControls());
        this.getSlides().forEach((slide) => {
          this.observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
        });
        this.updateControls();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      getSlides() {
        return Array.from(this.gallery.querySelectorAll('.product__media-list .product__media-item'));
      }

      getActiveIndex() {
        return this.getSlides().findIndex((slide) => slide.classList.contains('is-active'));
      }

      showMedia(step) {
        const slides = this.getSlides();
        const activeIndex = this.getActiveIndex();
        const targetIndex = activeIndex + step;
        const targetSlide = slides[targetIndex];
        if (!targetSlide) return;

        const targetId = targetSlide.dataset.mediaId;
        const thumbnail = Array.from(this.gallery.querySelectorAll('.thumbnail-list__item')).find(
          (item) => item.dataset.target === targetId
        );
        thumbnail?.querySelector('button')?.click();
      }

      updateControls() {
        const slides = this.getSlides();
        const activeIndex = this.getActiveIndex();
        this.previousButton.disabled = activeIndex <= 0;
        this.nextButton.disabled = activeIndex < 0 || activeIndex >= slides.length - 1;
      }
    }
  );
}
